import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ScrollRestorationService } from 'src/app/scroll-position-restoration.service';

@UntilDestroy()
@Component({
  selector: 'app-udder',
  templateUrl: './udder.component.html',
  styleUrls: ['./udder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UdderComponent implements OnInit {
  form!: FormGroup;

  get cows() {
    return this.form.get('cows');
  }

  get production() {
    return this.form.get('production');
  }

  get cells() {
    return this.form.get('cells');
  }

  get price() {
    return this.form.get('price');
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private scrollRestorationService: ScrollRestorationService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  onSubmitForm() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      this.router.navigate(['/juverhalsa/resultat'], {
        queryParams: {
          ...this.form.value,
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  private initForm() {
    const { cows, production, cells, price } = this.activatedRoute.snapshot.queryParams;

    /** Make sure to accept only valid values from query */
    const defaultCows = parseInt(cows, 10) || null;
    const defaultProduction = parseInt(production, 10) || null;
    const defaultCells = parseInt(cells, 10) || null;
    const defaultPrice = parseFloat(price) || null;

    this.form = this.fb.group({
      cows: [defaultCows, [Validators.required, Validators.min(1)]],
      production: [defaultProduction, [Validators.required, , Validators.min(1000), Validators.max(20000)]],
      cells: [defaultCells, [Validators.required, Validators.min(151), Validators.max(999)]],
      price: [defaultPrice || 4.3, [Validators.required, Validators.min(2), Validators.max(10)]],
    });

    /** Store form values as URL query */
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      this.scrollRestorationService.prevent();
      this.router.navigate([], {
        replaceUrl: true,
        queryParams: { ...this.form.value },
        queryParamsHandling: 'merge',
      });

      this.cd.markForCheck();
    });
  }
}
